/**
 * This file is used to define all section strings.
 * For example, `/medical-records/2/section-${FPP_SECTION}`
 * should forward user to fpp section of medical record
 * detail page.
 */
module.exports = {
  FPP_SECTION: 'fpp',
  WOUND_SECTION: 'wound',
};



// WEBPACK FOOTER //
// ./src/constants/SectionNames.js